if (!customElements.get('marquee-component')) {
  class MarqueeComponent extends HTMLElement {
    constructor() {
      super();

      this.popup = this.querySelector('[data-marquee-popup]');

      if (!this.popup) return;

      this.popupImages = Array.from(this.popup.querySelectorAll('img'));
      this.isRunning = false;
    }

    connectedCallback() {
      if (!this.popup) return;

      this.addEventListener('mouseleave', (e) => {
        setTimeout(() => {
          this.popup.classList.remove('is-visible');
        }, 100);
      });

      this.addEventListener('mousemove', (e) => {
        if (!this.isRunning) {
          this.isRunning = true;
          requestAnimationFrame(() => {
            this.handleMousemove(e);
            this.isRunning = false;
          });
        }
      });
    }

    handleMousemove(e) {
      this.style.setProperty('--cursor-position-x', `${e.clientX}px`);
      this.style.setProperty('--cursor-position-y', `${e.clientY}px`);

      if (!e.target.hasAttribute('data-marquee-text')) return;

      const marqueeText = e.target;

      this.popupImages.forEach((image, i) => {
        const matchesText = image.dataset.id === marqueeText.dataset.id;

        image.classList.toggle('is-visible', matchesText);
      });
      this.popup.classList.add('is-visible');
    }
  }

  customElements.define('marquee-component', MarqueeComponent);
}
